/**
 * Home — Page script
 * Importa apenas os módulos necessários para a Home
 */

import { initAOS }             from '../modules/UI/aos-init.js';
import { initHero }             from '../modules/UI/hero.js';
import { initSplitSections }    from '../modules/Components/split-section.js';
import { initFundCarousel }     from '../modules/Components/fund-carousel.js';
import { initColumnsSlider }    from '../modules/Components/columns-slider.js';
import { initNewsletter }       from '../modules/Components/newsletter.js';
import { initVideoPlayer }      from '../modules/Components/video-player.js';
import { initStickyNav }        from '../modules/Components/sticky-nav.js';
import { initFundChart }        from '../modules/Components/fund-chart.js';
import { initDailyRate }        from '../modules/Components/daily-rate.js';
import { initSectionConteudos } from '../modules/Components/section-conteudos.js';

function init() {
	initAOS();
	initHero();
	initSplitSections();
	initFundCarousel();
	initColumnsSlider();
	initNewsletter();
	initVideoPlayer();
	initStickyNav();
	initFundChart();
	initDailyRate();
	initSectionConteudos();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
